import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormsModule, ReactiveFormsModule, UntypedFormGroup, Validators} from '@angular/forms';
import {CompanyMsService} from 'src/app/services/shared/company-ms.service';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {DialogHeaderComponent} from 'src/app/shared/components/dialog-header/dialog-header.component';
import {DropdownModule} from 'primeng/dropdown';
import {MatInputModule} from '@angular/material/input';
import {BusinessEntityType} from 'src/app/shared/enums/BusinessEntityType.enum';
import {ButtonsComponent} from 'src/app/shared/components/buttons/buttons.component';
import {EnumStringPipe} from 'src/app/shared/pipes/EnumToString.pipe';
import {CompanyDetails} from 'src/app/dashboard/models/companyDetails.model';
import {EMPTY, catchError, take, tap} from 'rxjs';

const ANGULAR_MATERIAL = [MatIconModule, MatButtonModule, MatDialogModule, MatInputModule];
const PRIME_NG = [DropdownModule];
const STANDALONE_COMPONENT = [DialogHeaderComponent, ButtonsComponent];
const STANDALONE_PIPE = [EnumStringPipe];

@Component({
  selector: 'terra-create-edit-company',
  standalone: true,
  imports: [CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ...ANGULAR_MATERIAL,
    ...PRIME_NG,
    ...STANDALONE_COMPONENT,
    ...STANDALONE_PIPE],
  templateUrl: './create-edit-company.component.html',
  styleUrls: ['./create-edit-company.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateEditCompanyComponent implements OnInit {

  pageForm: UntypedFormGroup;

  EntityType = BusinessEntityType;
  entityTypes = BusinessEntityType.listAll();


  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<CreateEditCompanyComponent>,
    @Inject(MAT_DIALOG_DATA) public context: CompanyDetails,
    private companyMsService: CompanyMsService
  ) {
    this.dialogRef.updateSize('400px');

    this.pageForm = fb.group({
      name: [!!this.context?.id ? this.context.name : '', [Validators.required]],
      entityType: [!!this.context?.id ? this.context.entityType : BusinessEntityType.LLC, [Validators.required]]
    });
  }

  ngOnInit(): void {
  }

  populateForm() {

  }

  save() {
    if (this.pageForm.invalid) {
      return;
    }

    const company = new CompanyDetails();
    company.id = this.context?.id;
    company.name = this.pageForm.get('name').value
    company.entityType = this.pageForm.get('entityType').value

    const companyObservable = !!this.context?.id ? this.companyMsService.updateCompanyDetails(company) : this.companyMsService.addCompanyDetails(company)
    companyObservable.pipe(
      take(1),
      tap(result => this.dialogRef.close(result)),
      catchError(err => {console.error(err); return EMPTY;})
    ).subscribe()
  }

  cancel() {
    this.dialogRef.close();
  }



}
